import React from "react";
import ButtonUnstyled from "@mui/core/ButtonUnstyled";
import InputUnstyled, {
  InputUnstyledProps,
  inputUnstyledClasses,
} from "@mui/core/InputUnstyled";
import { styled } from "@mui/system";
import { InputLabel } from "@mui/material";
import theme from "../../global-styles/theme";
const blue = {
  100: "#DAECFF",
  200: "#80BFFF",
  400: "#3399FF",
  600: "#0072E5",
};

const grey = {
  50: "#F3F6F9",
  100: "#E7EBF0",
  200: "#E0E3E7",
  300: "#CDD2D7",
  400: "#B2BAC2",
  500: "#A0AAB4",
  600: "#6F7E8C",
  700: "#3E5060",
  800: "#2D3843",
  900: "#1A2027",
};

const StyledInputRoot = styled("div")(
  () => `  
  display: flex;
	width: auto;	
	height: 47px;
  font-weight: 500;
  border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[300]};
  border-radius: 8px;
  background: ${
    theme.palette.mode === "dark" ? grey[900] : theme.palette.secondary.light
  };
  align-items: center;
  justify-content: center;

  &.${inputUnstyledClasses.focused} {
    outline: 1.5px solid ${
      theme.palette.mode === "dark" ? blue[600] : theme.palette.primary.main
    };
		box-shadow: 0px 12px 24px rgba(46, 49, 58, 0.12);	
  }

  &:hover {
    background: ${theme.palette.mode === "dark" ? "" : theme.palette.info.main};
    border-color: ${theme.palette.mode === "dark" ? grey[700] : grey[400]};
		box-shadow: 0px 12px 24px rgba(46, 49, 58, 0.12);	
  }
	&.Mui-error{
		outline: 1.5px solid red;
	}
	
`
);

const StyledInputElement = styled("input")(
  () => `
	width: 100%;	
	height: auto;
  font-size: 0.875rem;
  line-height: 1.5;
  flex-grow: 1;
	background-color: ${
    theme.palette.mode === "dark" ? grey[900] : "rgba(0,0,0,0)"
  };
  color: ${
    theme.palette.mode === "dark" ? grey[300] : theme.palette.primary.dark
  };
  // background: inherit;
  border: none;
  border-radius: inherit;
  // padding: 12px 12px;
  outline: 0;
	padding: 10px;
`
);

const IconButton = styled(ButtonUnstyled)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: inherit;
  cursor: pointer;
`;

const InputAdornment = styled("div")`
  margin: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.MuiSvgIcon-root {
    color: "#111D3B";
  }
`;

const CustomInputLabel = styled(InputLabel)(() => ({
  letterSpacing: 2,
  color: "#555",
  top: "10px",

  "&.Mui-focused": {
    color: "#fff",
  },
  "&.MuiInputLabel-shrink": {
    top: 0,
  },
}));

const CustomInputBase = React.forwardRef(function CustomInput(
  props: InputUnstyledProps,
  _ref: unknown
) {
  const { components, ...other } = props;

  return (
    <InputUnstyled
      components={{
        Root: StyledInputRoot,
        Input: StyledInputElement,
        ...components,
      }}
      {...other}
    />
  );
});

export { CustomInputBase, InputAdornment, IconButton, CustomInputLabel };
